import React, { Component, Fragment } from 'react'
import { Container, Row, Col} from 'react-bootstrap'
import designIcon from '../../asset/image/bg.png'
import ddIcon from '../../asset/image/dd.png'
import flIcon from '../../asset/image/fl.png'
import '../../asset/css/custom.css';
import '../../asset/css/bootstrap.min.css';

export class services extends Component {
  render() {
    return (
      <Fragment>
        <Container className='text-center '>
            <h1 className='h1Tag'>My Services</h1>
            <div className='bottom'></div>
            <Row>
                <Col lg={4} md={6} sm={12}>
                <div className='serviceCard text-center'>
                 <img className='photoedit' src={designIcon}></img>
                 <h2 className='h2Tag'>Wedding Event</h2>
                 <p className='pTag'>yoo</p>
                 </div>
                </Col>
                 <Col lg={4} md={6} sm={12}>
                  <div className='serviceCard text-center'>
                 <img className='photoedit' src={ddIcon}></img>
                  <h2 className='h2Tag'>Detective</h2>
                 <p className='pTag'>gjg</p>
                 </div>
                </Col>
                 <Col lg={4} md={6} sm={12} >
                  <div className='serviceCard text-center'>
                <img className='photoedit' src={flIcon}></img>
                 <h2 className='h2Tag'>Birthday Event</h2>
                 <p className='pTag'>mm</p>
                 </div>
                </Col>
            </Row>
        </Container>

      </Fragment>
    )
  }
}

export default services
